import React from 'react';
import type { Message } from '../types';

const NOTIFICATION_SOUND_DATA_URI = 'data:audio/wav;base64,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.pi9rb4AABHB5cJ2wVi/8n6Qfp7/MX+7v/xAAgDcQWVBbEBTvvJ9u73hv4hBoYJyAaIAGX7J/oN/HX+yP+vAIoCBQXDBaUChfxg9133H/3dBD8JkQexASH8Kfqm+xz+nv95ABUCjQTNBXcDvP0h+AP31PuDA8MILgjWAvj8SvpK+739cP9LAK0BDgS2BSQE6/4F+eL2q/odAhUInQjvA+f9i/r8+lf9O/8jAFEBjQODBasECwAE+vb2rPmzADwH2gj1BOj+7frB+vD8/v4AAAIBDgM5BQwFFgEX+z732vhP/zwG5AjhBfb/bvuc+on8uP7e/8AAlALcBEgFBwI1/LT3Ovj4/RwFuwisBggBDvyR+ib8af65/4gAIwJxBGEF2gJW/VX4zfe3/OUDYAhTBxsCyfyh+sv7FP6R/1oAvQH+A1oFiwN0/hn5lPeT+50C1gfQByYDnf3O+nv7uP1j/zMAYgGHAzgFGgSH//r5jveT+k4BIAcgCCIEg/4a+zv7Wf0u/xAAEgEQA/0EhgSJAPD6ufe6+QAAQwZBCAoFeP+D+w77+Pzx/vD/zwCcAq8EzgR1AfX7EvgO+bv+RgUyCNYFdQAK/Pj6mvys/tD/lwAvAlIE9gRHAgH9lPiR+Ib9MAT1B4MGdQGr/Pn6Qvxg/qz/aADLAeoD/gT7Ag3+OvlE+Gn8BgOKBwoHcQJk/Rb78vsN/oT/QABxAX0D6gSQAxL//vkn+Gr70gH1BmoHYwMy/k77r/u2/Vb/HgAiAQ4DvwQEBAkA2fo4+I76mgA6Bp4HRAQP/6L7fPtd/SL/AADeAKECfgRYBO8Axvt2+Nn5aP9eBacHDwX3/xH8XfsE/eX+4v+lADgCLwSLBL8BvPzc+E/5Qf5mBIQHvgXjAJv8Uvuv/KL+w/91ANcB0wOhBHQCtf1m+fH4LP1aAzUHTgbQATz9YPth/Fj+oP9NAH8BcAObBA0Dq/4P+sD4MfxAAr4GuQa1AvL9h/sc/An+ef8rADABCQN+BIgDmP/R+rv4VPsfASIG/gaPA7j+yPvl+7f9S/8OAOwAowJLBOQDdQCl++D4mvoAAGQFGwdWBIv/I/y/+2X9F//z/7IAPwIIBCMEQQGF/Cz5Bvro/ooEDgcGBWQAl/yr+xP92/7W/4IA4QG4A0UE9gFs/Zz5mvne/ZoD2QabBUEBIv2t+8f8mv64/1kAiwFfA0wEkQJT/iv6WPnp/JoCfQYPBhoCwf3F+4P8U/6W/zcAPQEBAzsEEQMz/9T6P/kN/JEB/QVhBuoCcv71+0n8CP5u/xoA+QChAhUEdQMIAJH7TvlQ+4UAXAWPBqwDMf8+/B38u/1B/wAAvwBDAt4DvQPOAF38g/m1+n3/ngSWBlsE+P+e/AL8b/0N/+f/jgDpAZkD6QOAATH92/k++n/+yQN4BvIEwwAU/fn7Jf3T/sz/ZQCVAUoD/AMcAgf+Uvrt+ZH94gI0Bm0FjwGf/QX84vyT/q7/QgBJAfUC9wOgAtv+4/rD+bn88AHOBckFVQI7/if8p/xP/oz/JQAGAZ0C3QMKA6f/ivu++fv79wBHBQUGEAPm/l/8ePwJ/mT/DADLAEQCsgNZA2UAQPze+Vv7AACkBB0GuwOc/638V/zC/Tf/9f+ZAO8BeAOPAxQBAv0g+tv6D//oAxIGUwRWABH9Rvx8/QT/3P9wAJ4BMwOsA7AByP2A+n76Kv4aA+UF0wQUAYj9R/w6/cz+wv9NAFQB5wKzAzUCjv77+kX6V/09ApYFNwXPARH+XPz//I/+pP8wABEBlgKkA6QCUP+N+zD6mvxZAScFfgWCAqr+hfzO/E7+gv8WANcAQwKEA/oCBwAv/D369/tyAJ0EpQUpA07/xPyo/Az+W/8AAKQA8gFUAzcDsQDe/Gr6cfuQ//kDqwW/A/r/Fv2Q/Mr9L//q/3oA';
export const NOTIFICATION_SOUND_STORAGE_KEY = 'ally.preferences.notificationSound';
export const NOTIFICATION_SOUND_BACKGROUND_ONLY_STORAGE_KEY = 'ally.preferences.notificationSound.backgroundOnly';
const MIN_SOUND_INTERVAL_MS = 3000;
const NOTIFICATION_SOUND_VOLUME = 0.4;

// D6-04 (FE-2.13): let users hear the completion chime from Settings before
// deciding whether to keep it on. Plays at the same volume as the real
// notification. Returns a promise that resolves when playback starts (or
// resolves anyway if the browser blocks/lacks audio — preview is best-effort).
export async function playNotificationSoundPreview(): Promise<void> {
  if (typeof Audio === 'undefined') {
    return;
  }

  try {
    const audio = new Audio(NOTIFICATION_SOUND_DATA_URI);
    audio.volume = NOTIFICATION_SOUND_VOLUME;
    await audio.play();
  } catch (error) {
    console.debug('Notification sound preview skipped:', error);
  }
}

export interface NotificationSoundPreferences {
  enabled: boolean;
  backgroundOnly: boolean;
}

export function readNotificationSoundPreferences(): NotificationSoundPreferences {
  if (typeof window === 'undefined') {
    return { enabled: true, backgroundOnly: true };
  }

  const storedEnabled = window.localStorage.getItem(NOTIFICATION_SOUND_STORAGE_KEY);
  const storedBackgroundOnly = window.localStorage.getItem(NOTIFICATION_SOUND_BACKGROUND_ONLY_STORAGE_KEY);

  return {
    enabled: storedEnabled === null ? true : storedEnabled === 'true',
    backgroundOnly: storedBackgroundOnly === null ? true : storedBackgroundOnly === 'true',
  };
}

export function writeNotificationSoundPreferences(preferences: NotificationSoundPreferences) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(NOTIFICATION_SOUND_STORAGE_KEY, String(preferences.enabled));
  window.localStorage.setItem(NOTIFICATION_SOUND_BACKGROUND_ONLY_STORAGE_KEY, String(preferences.backgroundOnly));
}

function shouldPlayForVisibility(backgroundOnly: boolean) {
  if (typeof document === 'undefined') {
    return false;
  }

  if (!backgroundOnly) {
    return true;
  }

  return document.visibilityState !== 'visible' || !document.hasFocus();
}

export function useNotificationSound(messagesByConversation: Record<string, Message[]>) {
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const previousStatusesRef = React.useRef<Record<string, string | undefined>>({});
  const initializedRef = React.useRef(false);
  const lastPlayedAtRef = React.useRef(0);

  React.useEffect(() => {
    if (typeof Audio === 'undefined') {
      return;
    }

    const audio = new Audio(NOTIFICATION_SOUND_DATA_URI);
    audio.preload = 'auto';
    audio.volume = NOTIFICATION_SOUND_VOLUME;
    audioRef.current = audio;
  }, []);

  React.useEffect(() => {
    const currentStatuses: Record<string, string | undefined> = {};
    let completedAssistantMessage = false;

    for (const messages of Object.values(messagesByConversation)) {
      for (const message of messages) {
        if (message.role !== 'assistant') {
          continue;
        }

        currentStatuses[message.id] = message.status;
        const previousStatus = previousStatusesRef.current[message.id];
        if (
          initializedRef.current
          && previousStatus === 'streaming'
          && message.status
          && message.status !== 'streaming'
          && message.status !== 'failed'
          && !message.isError
        ) {
          completedAssistantMessage = true;
        }
      }
    }

    previousStatusesRef.current = currentStatuses;

    if (!initializedRef.current) {
      initializedRef.current = true;
      return;
    }

    if (!completedAssistantMessage) {
      return;
    }

    const preferences = readNotificationSoundPreferences();
    if (!preferences.enabled || !shouldPlayForVisibility(preferences.backgroundOnly)) {
      return;
    }

    const now = Date.now();
    if (now - lastPlayedAtRef.current < MIN_SOUND_INTERVAL_MS) {
      return;
    }
    lastPlayedAtRef.current = now;

    const audio = audioRef.current;
    if (!audio) {
      return;
    }

    try {
      audio.pause();
      audio.currentTime = 0;
      void audio.play().catch((error) => {
        console.debug('Notification sound playback skipped:', error);
      });
    } catch (error) {
      console.debug('Notification sound playback failed:', error);
    }
  }, [messagesByConversation]);
}

export default useNotificationSound;
